import React from "react";

/**
 * Subtle molecular / geometric background motif rendered as thin gold lines.
 * Purely decorative — hidden from assistive tech.
 */
export default function MoleculeBg({ className = "", color = "#C8A96A", opacity = 0.18 }) {
  return (
    <svg
      className={className}
      viewBox="0 0 600 600"
      fill="none"
      aria-hidden="true"
      style={{ opacity }}
      preserveAspectRatio="xMidYMid slice"
    >
      <g stroke={color} strokeWidth="1">
        <circle cx="120" cy="140" r="5" fill={color} />
        <circle cx="260" cy="90" r="5" fill={color} />
        <circle cx="400" cy="160" r="5" fill={color} />
        <circle cx="520" cy="90" r="5" fill={color} />
        <circle cx="180" cy="300" r="5" fill={color} />
        <circle cx="330" cy="270" r="5" fill={color} />
        <circle cx="470" cy="330" r="5" fill={color} />
        <circle cx="120" cy="460" r="5" fill={color} />
        <circle cx="300" cy="480" r="5" fill={color} />
        <circle cx="500" cy="470" r="5" fill={color} />
        <path d="M120 140 L260 90 L400 160 L520 90" />
        <path d="M120 140 L180 300 L330 270 L400 160" />
        <path d="M180 300 L120 460 L300 480 L330 270" />
        <path d="M330 270 L470 330 L500 470 L300 480" />
        <path d="M400 160 L470 330" />
      </g>
    </svg>
  );
}

/** Vertical DNA double-helix line motif. */
export function HelixMotif({ className = "", color = "#C8A96A", opacity = 0.5 }) {
  const rungs = Array.from({ length: 9 });
  return (
    <svg
      className={className}
      viewBox="0 0 80 320"
      fill="none"
      aria-hidden="true"
      style={{ opacity }}
    >
      <path
        d="M20 0 C 60 40, 60 80, 20 120 C -20 160, -20 200, 20 240 C 60 280, 60 320, 20 360"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M60 0 C 20 40, 20 80, 60 120 C 100 160, 100 200, 60 240 C 20 280, 20 320, 60 360"
        stroke={color}
        strokeWidth="1.2"
      />
      {rungs.map((_, i) => (
        <line
          key={i}
          x1="20"
          x2="60"
          y1={20 + i * 34}
          y2={20 + i * 34}
          stroke={color}
          strokeWidth="0.8"
        />
      ))}
    </svg>
  );
}
